import React, { ReactNode } from "react";

import { AnimateTranslate, HeadingText } from "styles";

type Props = {
  children: ReactNode;
};

export const PageHeaderTitle = (props: Props) => {
  return (
    <AnimateTranslate>
      <HeadingText $variant="heading01" className="pb-2" as="h1">
        {props.children}
      </HeadingText>
    </AnimateTranslate>
  );
};
